import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import Alert from '@anm/components/notification/Alert';
import { FC } from 'react';

import {
  DiscountInfoDescription,
  DiscountInfoDescriptionItem,
  DiscountInfoDescriptionItemText,
  DiscountInfoTitle,
  DiscountInfoWrapper,
  DiscountView,
  PeriodName
} from './Wrapper';

export type DiscountInfoBlockProps = {
  planName: string;
  planPrice: number;
  periodName: SubscriptionPeriod;
  credit?: number;
  annualDiscount?: number;
  amountDiscount?: number;
  percentsDiscount?: number;
};

const DiscountInfoBlock: FC<DiscountInfoBlockProps> = ({
  credit,
  planName,
  planPrice,
  periodName,
  annualDiscount,
  amountDiscount,
  percentsDiscount
}) => (
  <DiscountInfoWrapper>
    <DiscountInfoTitle>
      <Alert variant="success" position="left">
        You will receive a credit for the unused period of your existing plan
      </Alert>
    </DiscountInfoTitle>
    <DiscountInfoDescription>
      <DiscountInfoDescriptionItem>
        <DiscountInfoDescriptionItemText>
          <span>{planName} </span>
          <span>Plan </span>
          <PeriodName>{periodName.toLowerCase()}</PeriodName>
        </DiscountInfoDescriptionItemText>
        <div>${planPrice}</div>
      </DiscountInfoDescriptionItem>

      {annualDiscount && (
        <DiscountInfoDescriptionItem>
          <DiscountInfoDescriptionItemText>
            Annual discount
          </DiscountInfoDescriptionItemText>
          <DiscountView>${annualDiscount}</DiscountView>
        </DiscountInfoDescriptionItem>
      )}

      {(amountDiscount || percentsDiscount) && (
        <DiscountInfoDescriptionItem>
          <DiscountInfoDescriptionItemText>
            Additional discount
          </DiscountInfoDescriptionItemText>
          <DiscountView>
            {amountDiscount && <span>${amountDiscount}</span>}
            {percentsDiscount && <span>{percentsDiscount}%</span>}
          </DiscountView>
        </DiscountInfoDescriptionItem>
      )}

      <DiscountInfoDescriptionItem>
        <DiscountInfoDescriptionItemText>
          Unused credit
        </DiscountInfoDescriptionItemText>
        <DiscountView>${credit}</DiscountView>
      </DiscountInfoDescriptionItem>
    </DiscountInfoDescription>
  </DiscountInfoWrapper>
);

export default DiscountInfoBlock;
